export const handleDeskFields = (intent) => {
    const info = intent.desks?.info;
    if (!info) return;
  
    const {
      zendesk_ticket_status,
      zendesk_mode,
      centridesk_ticket_status,
      centridesk_mode,
    } = info;
  
    switch (intent.desks.name) {
      case "zendesk_full":
        info.ticket_status = zendesk_ticket_status;
        info.mode = zendesk_mode;
        break;
      case "centridesk":
        info.ticket_status = centridesk_ticket_status;
        info.mode = centridesk_mode;
        break;
      case "gpt-3":
        intent.desks.info = {
          max_tokens: info.max_tokens,
          max_interactions: info.max_interactions,
        };
        break;
      default:
        delete info.max_tokens;
        delete info.max_interactions;
    }
  
    delete info.zendesk_ticket_status;
    delete info.centridesk_ticket_status;
    delete info.zendesk_mode;
    delete info.centridesk_mode;
  };